import React from 'react';
import SearchInputForContentBase from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/searchInputForContentBase';

function SearchInputForContentOfUmuMicroPage(props: any) {
    return (
        <div className="search-input-for-content search-input-for-content__umu-normal">
            <SearchInputForContentBase inputType="umuCommon" {...props} />
        </div>
    );
}

export default SearchInputForContentOfUmuMicroPage;
